class ProductRecommendations extends HTMLElement {
  constructor() {
    super();  
    this.hasContent = this.innerHTML.trim().length;
    
    if(!this.hasContent) {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          this.setContent(text)
        })
        .catch(e => {
          console.error(e);
        });

    }
  }

  setContent(text) {
    const html = document.createElement('div');
    html.innerHTML = text;
    const recommendations = html.querySelector('product-recommendations');
    this.innerHTML = recommendations.innerHTML;
    // Initialize Scroll events to set correct scroll position
    scrollEvents && scrollEvents.initialize()
  }
}

customElements.define('product-recommendations', ProductRecommendations);